<template>
	<div>
		<div class="welcome-login text-center">
			<!-- display the district info -->
            <img v-if="logoSrc" :src="logoSrc" :alt="districtName + ' logo'"/>
            <h3 class="district-name">{{ districtName }}</h3>
			<hr/>
            <h3>{{ title }}</h3>
            <p v-if="loginText">
                {{ loginText }}
            </p>
            <!-- display any messages ( allowing html formatting ) -->
            <div v-if="getActiveMessage"
            	id="formFeedback"
            	:class="getMessageClass"
                v-html="getActiveMessage.content">
            </div>
        </div>
        <form method="post" ref="form" @submit.prevent="validateBeforeSubmit" :action="postEndpoint">
            <input type="hidden" name="_csrftoken" :value="csrfToken" />
            <div v-if="showUsername" class="form-group"  :class="{'has-warning': errors.has('username') }">
                <label for="username">
                    Username
                </label>
                <input 
                	type="text" 
                	class="form-control" 
                	name="username" 
                	v-model="username" 
                	v-validate="'required'"
                    autocomplete="off">
                
                <div v-show="errors.has( 'username' )">
                    <small class="invalid-feedback">{{ errors.first( 'username' ) }}</small>
                </div>
            </div>
            
            <div v-if="showEmail" class="form-group"  :class="{'has-warning': errors.has('email') }">
                <label for="email">
                    Your email:
                </label>
                <input 
                	type="email" 
                	class="form-control" 
                	name="email" 
                	v-model="email" 
                	v-validate="'required'"
                    autocomplete="off">
                
                <div v-show="errors.has( 'email' )">
                    <small class="invalid-feedback">{{ errors.first( 'email' ) }}</small>
                </div>
            </div>
             <div v-if="!showPin" class="form-group"  :class="{'has-warning': errors.has('pin') }">
                 <a href="javascript:void(0);" @click="showPin=true;">I have a PIN</a>
             </div>
            <div v-if="showPin" class="form-group"  :class="{'has-warning': errors.has('pin') }">
                <label for="pin">
                    PIN
                </label>
                <input 
                    type="password" 
                    class="form-control" 
                    name="pin" 
                    v-model="pin" 
                    v-validate="'numeric'"
                    autocomplete="off">
                
                <div v-show="errors.has( 'pin' )">
                    <small class="invalid-feedback">{{ errors.first( 'pin' ) }}</small>
                </div>
            </div>

            <div class="">
                <button 
              		type="submit"
                	class="btn btn-block btn-primary"
                	:disabled="isFormInvalid">
                    Continue
                </button>
            </div>
        </form>
       
        <div class="go-back">
            <a :href="entrypoint"><i class="fas fa-chevron-left"></i> Go Back</a>
        </div>
    </div>
    
</template>
                
<script>
    export default{
        props:{
			csrfToken : "",
        	districtName : "",
            logoSrc : "",
            loginText : {
                type: String
            },
        	message : {
        		type: Object,
				default: function(){
					return {
						category: "info",
						content: "Please enter the following:"
					}
				}
            },
            title: {
                type: String,
                default : "Forgot Password"
            },
            entrypoint : {
				type: String,
				required: true
			},
			postEndpoint : {
				type: String,
				required: true
            },
            showEmail : {
                type : Boolean,
                default : true
            },
            showUsername : {
                type : Boolean,
                default : false
            }
        },
        data(){
            return{
            	username: "",
                password: "",
                email: "",
                pin: "",
                showPin:false
            }
        },
        computed: {
    		isFormInvalid() {
      			return Object.keys( this.fields ).some( key => this.fields[ key ].invalid );
    		},
    		isFormTouched() {
    			return Object.keys( this.fields ).some( key => this.fields[ key ].touched );
    		},
    		getMessageClass() {
    			return "alert alert-" + this.getActiveMessage.category;
    		},
    		getActiveMessage() {
    			if( this.isFormInvalid && this.isFormTouched ){
    				return {
    					category : "warning",
    					content : "Some required fields are missing!"
    				}
    			} else{
    				return this.message;
    			}
    		}

  		},
        methods: {
            validateBeforeSubmit() {
                this.$validator.validateAll().then((result) => {
	                if (result) {
	                    this.$refs.form.submit();
	                    return;
	                }

	                           	});
            }
        }  
    }
</script>